import { createAction } from 'redux-actions';
export const SET_REFUND_LOADING = 'REFUND/SET_REFUND_LOADING';
export const setRefundLoading = createAction(SET_REFUND_LOADING, (operation, status) => ({
    operation,
    status
}));
